module.exports = __webpack_public_path__ + "static/media/eliza-jane-lose.3b771952.jpg";